import { setting } from "../setting";

export const medalRequirement = (num: number): number => {
  return setting.medalLevels.reduce(
    (acc, cur) => (num < cur ? acc : acc + 1),
    0
  );
};
